(() => {
    let prices, bold;
    function storeDefaultPrices() {
        prices.forEach((price) => {
            price.setAttribute('data-price', price.textContent.replace(/[^0-9\.]/g, ''));
        })
    }
    function showAddonCharge() {
        let addon = document.querySelector('.bold_option_total div span');
        prices.forEach((price) => {
            price.textContent = (parseFloat(price.getAttribute('data-price')) + (addon ? parseFloat(addon.textContent.replace(/[^0-9\.]/g, '')) : 0)).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 });
        })
    }

    function updateNewPrices(){
        prices = document.querySelectorAll('.purchase-details [data-price].money');
    }
    window.addEventListener('load', function () {
        BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function (event) {
            bold = document.querySelectorAll('.bold_option_set, .bold_option_checkbox');
            const hook = setInterval(()=>{
              updateNewPrices();
              if (prices.length){
                clearInterval(hook);
                storeDefaultPrices();
                bold.forEach((el)=> el.addEventListener('change', (event) => {
                    setTimeout(showAddonCharge, 100);
                }))
                document.querySelector('.single-option-selector').addEventListener('change',()=>{
                    setTimeout(updateNewPrices,0);
                    setTimeout(storeDefaultPrices,50);
                    setTimeout(showAddonCharge,100);
                })
              }
            },150)
        })
    })
})()